module.exports = __webpack_public_path__ + "static/c21-3c760b2a8b9d00521eb51fd07e930b73.jpg";